import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { IconMenu2, IconLogout } from "@tabler/icons-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { NotificationBell } from "@/features/notifications/components/NotificationBell";
import { useAuthStore } from "@/features/auth/stores/authStore";

export function Topbar({ onMenuClick }: { onMenuClick?: () => void }) {
  const { t } = useTranslation(["backoffice", "common"]);
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);

  const initials = (user?.name ?? "ImobGo")
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b border-border bg-white/80 px-3 backdrop-blur md:px-5">
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="Abrir menu"
        className="flex h-9 w-9 items-center justify-center rounded-lg text-ink-muted hover:bg-bg lg:hidden"
      >
        <IconMenu2 size={20} />
      </button>

      <div className="flex-1" />

      <div className="flex items-center gap-2.5">
        <NotificationBell />
        {user?.role && (
          <Badge variant="info" className="hidden sm:inline-flex">
            {t(`roles.${user.role}`)}
          </Badge>
        )}
        <Link
          to="/profile"
          aria-label={t("backoffice:profile.title")}
          className="flex items-center gap-2.5 rounded-lg px-1 py-0.5 hover:bg-bg"
        >
          <div className="hidden text-right sm:block">
            <p className="text-[13px] font-semibold leading-tight">{user?.name}</p>
            <p className="text-[11px] text-ink-muted">{user?.email}</p>
          </div>
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-100 text-[12px] font-semibold text-brand-700">
            {initials}
          </span>
        </Link>
        <Button variant="ghost" size="icon" aria-label={t("common:actions.logout")} onClick={logout}>
          <IconLogout size={18} />
        </Button>
      </div>
    </header>
  );
}
